// level 1 to 8, 0 indexed...
export var OrganisationColumns;
(function (OrganisationColumns) {
    OrganisationColumns[OrganisationColumns["unitId"] = 4] = "unitId";
    OrganisationColumns[OrganisationColumns["divisionId"] = 5] = "divisionId";
    OrganisationColumns[OrganisationColumns["departmentId"] = 6] = "departmentId";
    OrganisationColumns[OrganisationColumns["activityId"] = 7] = "activityId";
})(OrganisationColumns || (OrganisationColumns = {}));
export var TransactionType;
(function (TransactionType) {
    TransactionType["Upload"] = "UPLOAD";
    TransactionType["Manual"] = "MANUAL";
    TransactionType["DayTemplate"] = "DAY_TEMPLATE";
    TransactionType["ManualDayTemplate"] = "MANUAL_DAY_TEMPLATE";
    TransactionType["Driver"] = "WORKLOAD_DRIVER";
})(TransactionType || (TransactionType = {}));
export var PlanPeriodSort;
(function (PlanPeriodSort) {
    PlanPeriodSort["ASC"] = "asc";
    PlanPeriodSort["DESC"] = "desc";
})(PlanPeriodSort || (PlanPeriodSort = {}));
//# sourceMappingURL=bq.types.mjs.map